export enum AdministrativeOptionsEnum {
    PDV_WINDOWS_DOWNLOAD = 1,
    PDV_ANDROID_DOWNLOAD = 2,
    EMAIL_SMART_POS_EC = 3,
    EMAIL_SUPORTE_FLIPE_ON = 4
}